
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M12.898 15.167c-.102-3.832 4.765-6.603 9.683-5.135s4.904-.116 8.495 2.373c3.592 2.489 4.258 8.048 4.223 10.972-.043 3.549-6.74 5.664-6.124 11.155.616 5.492-2.808 7.368-7.725 4.491-4.918-2.876-8.644-1.36-11.054-4.228C7.792 31.697 7 24.5 8.225 22.1 9.449 19.7 13 19 12.898 15.167M12.782 9.127c.692 1.505-.17 3.38-1.927 4.188-1.756.807-3.74.242-4.433-1.263s.17-3.38 1.926-4.188 3.741-.243 4.433 1.263M15 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-Vector",attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M32 36.167 40.167 28l3.5 3.5-8.167 8.167z"}}),_c('path',{staticClass:"i-Vector_2",attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"m39 29.167-1.75-8.75-16.917-4.084 4.084 16.917 8.75 1.75z"}}),_c('path',{staticClass:"i-Vector_3",attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"m20.333 16.333 8.85 8.85"}}),_c('path',{staticClass:"i-Vector_4",attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M30.833 29.167a2.333 2.333 0 1 0 0-4.667 2.333 2.333 0 0 0 0 4.667"}})])
          )
        }
      }
    